/**
 * @generated SignedSource<<301cde121abf1cf126ba45f0c79c027c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftSearchBarMobile_viewer$data = {
  readonly nftSearchSuggestion?: {
    readonly creators: ReadonlyArray<{
      readonly address: {
        readonly address: string | null;
        readonly publicProfile: {
          readonly avatarImage: {
            readonly path: string | null;
          } | null;
          readonly profileName: string | null;
        } | null;
        readonly publicProfileUrl: string | null;
      } | null;
      readonly nftItemCount: number | null;
    } | null> | null;
    readonly exhibitions: ReadonlyArray<{
      readonly modules: {
        readonly heroBanner: ReadonlyArray<{
          readonly bannerConfig: {
            readonly eyeBrow?: string | null;
          } | null;
          readonly desktopImage: {
            readonly url: string | null;
          } | null;
        } | null> | null;
      } | null;
      readonly pageName: string | null;
    } | null> | null;
    readonly items: ReadonlyArray<{
      readonly creatorAddress: {
        readonly publicProfile: {
          readonly profileName: string | null;
        } | null;
      } | null;
      readonly metadata: {
        readonly name?: string | null;
      } | null;
      readonly pdpUrl: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"NftItemTileMedia_item">;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "NftSearchBarMobile_viewer";
};
export type NftSearchBarMobile_viewer$key = {
  readonly " $data"?: NftSearchBarMobile_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftSearchBarMobile_viewer">;
};

import NftSearchBarMobileRefetchQuery_graphql from './NftSearchBarMobileRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profileName",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "hasQuery"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "query"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": NftSearchBarMobileRefetchQuery_graphql
    }
  },
  "name": "NftSearchBarMobile_viewer",
  "selections": [
    {
      "condition": "hasQuery",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "includeTypes",
              "value": [
                "ITEMS",
                "CREATORS",
                "EXHIBITIONS"
              ]
            },
            {
              "kind": "Variable",
              "name": "query",
              "variableName": "query"
            }
          ],
          "concreteType": "NftSearchSuggestion",
          "kind": "LinkedField",
          "name": "nftSearchSuggestion",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "NftItem",
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pdpUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "metadata",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        }
                      ],
                      "type": "NftDigitalArtMetadata",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EthereumAddressType",
                  "kind": "LinkedField",
                  "name": "creatorAddress",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PublicProfile",
                      "kind": "LinkedField",
                      "name": "publicProfile",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "NftItemTileMedia_item"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "NftCreatorsSearchResult",
              "kind": "LinkedField",
              "name": "creators",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EthereumAddressType",
                  "kind": "LinkedField",
                  "name": "address",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "address",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PublicProfile",
                      "kind": "LinkedField",
                      "name": "publicProfile",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Photo",
                          "kind": "LinkedField",
                          "name": "avatarImage",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "path",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "publicProfileUrl",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "nftItemCount",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "NftExhibitionSearchObject",
              "kind": "LinkedField",
              "name": "exhibitions",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pageName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "NftCmsExhibitionPage",
                  "kind": "LinkedField",
                  "name": "modules",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NftCmsExhibitionHeroBannerType",
                      "kind": "LinkedField",
                      "name": "heroBanner",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "NftCmsExhibitionImageType",
                          "kind": "LinkedField",
                          "name": "desktopImage",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "url",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "bannerConfig",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "eyeBrow",
                                  "storageKey": null
                                }
                              ],
                              "type": "NftCmsExhibitionHtmlBannerType",
                              "abstractKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "c09f0bb4e31661134b64adf1e7f0eaf2";

export default node;
